
import { Vue, Component } from 'vue-property-decorator'
import Company from '@/types/company'
import CompanyEditDetailsTab from '@/views/company/tabs/edit/CompanyEditDetailsTab.vue'
import CompanyEmployeesTab from '@/views/company/tabs/CompanyEmployeesTab.vue'
import CompanyEditConstructionWorkersTab from '@/views/company/tabs/edit/CompanyEditConstructionWorkersTab.vue'
import CompanyEditDocumentsTab from '@/views/company/tabs/edit/CompanyEditDocumentsTab.vue'
import ls from '@/ls'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: { CompanyEditDocumentsTab, CompanyEditConstructionWorkersTab, CompanyEditEmployeesTab: CompanyEmployeesTab, CompanyEditDetailsTab }
})

export default class CompanyEdit extends Vue {
  settings = {
    routeNames: { list: 'companies', show: 'companyShow', edit: 'companyEdit' },
    routeParamKey: 'companyId',
    functionNames: { setCurrent: 'setCurrentCompany', clearCurrent: 'clearCurrentCompany', save: 'saveCompany' },
    getterNames: { current: 'currentCompany', loading: 'loadingCompany', errors: 'companyErrors' }
  }

  currentTab:string = ls.get('companyEditActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('companyEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, id:number|undefined) : void {
    if (id) {
      this.$router.push({ name: routeName, params: { [this.settings.routeParamKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  syncCompany () : void {
    this.$store.dispatch('syncCompany', this.currentItem.id)
  }

  get currentItem () : Company {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get syncing () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].syncing
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
